// frontend/src/store/index.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import creditReducer from "./slices/creditSlice";
import esimReducer from "./slices/esimSlice";
import transactionReducer from "./slices/transactionSlice"; // Add this import
import profilesReducer from "./slices/profilesSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    credits: creditReducer,
    esim: esimReducer,
    transactions: transactionReducer, // Add this line
    profiles: profilesReducer,
  },
});
